import { Component, ElementRef, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, BehaviorSubject, takeUntil } from 'rxjs';
import { SectionStateStatus } from '../../common';
import { destroyStream, LoadingService } from '../../helper';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit , OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  isHidden$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @ViewChild('loadingOverlayPage', { static: true })
  loadingOverlayPage: ElementRef;

  // constructor
  constructor(
    private renderer: Renderer2,
    private loadingService: LoadingService
  ) {}

  // hooks
  ngOnDestroy(): void {
    destroyStream(this.destroy$);
  }

  ngOnInit(): void {
    this.listenToLoadingServiceStream();
  }

  // privates
  private showNotTransparent(): void {
    this.renderer.setStyle(
      this.loadingOverlayPage.nativeElement,
      'background',
      '#FFFFFF'
    );
    this.isHidden$.next(false);
  }

  private showTransparent(): void {
    this.renderer.setStyle(
      this.loadingOverlayPage.nativeElement,
      'background',
      '#40404033'
    );
    this.isHidden$.next(false);
  }

  private hide(): void {
    this.isHidden$.next(true);
  }

  private listenToLoadingServiceStream(): void {
    this.loadingService.loadingStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((status: SectionStateStatus) => {
        switch (status) {
          case SectionStateStatus.HideLoading:
            this.hide();
            break;

          case SectionStateStatus.Loading:
            this.showNotTransparent();
            break;

          case SectionStateStatus.LoadingTransparent:
            this.showTransparent();
            break;
        }
      });
  }

}
